import { useEffect, useState, useMemo, useImperativeHandle, forwardRef } from 'react'
import moment from 'moment'
import { checkEmptyValue } from '../../../plugins/common'
import axios from '../../../plugins/axios'
import { useTranslation } from 'react-i18next'

import Dropdown from './components/Dropdown'
import ListTable from './components/ListTable'
import DetailView from './components/DetailView'

import {ReactComponent as IconCloseBlack} from '../../../assets/icons/ic-close-black.svg'

const LeadModal = forwardRef(({ handleClose }, ref) => {
    const { t } = useTranslation()
    const [view, setView] = useState('list')
    const [category, setCategory] = useState('12LEAD')
    const [editCategory, setEditCategory] = useState('12LEAD')
    const [year, setYear] = useState({ label: '2026', value: '2026' })
    const [month, setMonth] = useState({ label: '08', value: '08' })
    const [day, setDay] = useState({ label: '20', value: '20' })
    const [dayValueArr, setDayValueArr] = useState([])
    const [selectedData, setSelectedData] = useState(null)
    const [isInitialized, setIsInitialized] = useState(false);
    const [data, setData] = useState([])

    const [dropdownStates, setDropdownStates] = useState({
        year: false,
        month: false,
        day: false,
    });

    // const yearValueArr = [
    //     { label: '2026', value: '2026' }, { label: '2025', value: '2025' }, { label: '2024', value: '2024' }, { label: '2023', value: '2023' }, { label: '2022', value: '2022' },
    //     { label: '2021', value: '2021' }, { label: '2020', value: '2020' }, { label: '2019', value: '2019' }, { label: '2018', value: '2018' },
    //     { label: '2017', value: '2017' }, { label: '2016', value: '2016' }, { label: '2015', value: '2015' }
    // ]

    // yearValueArr를 useMemo로 변경
    const yearValueArr = useMemo(() => {
        const currentYear = moment().year();
        const years = [];
        
        // 현재 연도부터 20년 전까지
        for (let i = 0; i <= 20; i++) {
            const year = (currentYear - i).toString();
            years.push({ label: year, value: year });
        }
        
        return years;
    }, []);

    const monthValueArr = [
        { label: '01', value: '01' }, { label: '02', value: '02' }, { label: '03', value: '03' }, { label: '04', value: '04' },
        { label: '05', value: '05' }, { label: '06', value: '06' }, { label: '07', value: '07' }, { label: '08', value: '08' },
        { label: '09', value: '09' }, { label: '10', value: '10' }, { label: '11', value: '11' }, { label: '12', value: '12' }
    ]

    // 1400px
    const LEADTableHeaders = useMemo(() => [
        { label: t('leadModal.time'), width: '320px', key: 'eventDt' }, { label: t('leadModal.serialNumber'), width: '320px', key: 'serial' }, 
        { label: t('leadModal.patientId'), width: '320px', key: 'devicePatientId' }, { label: t('leadModal.fileName'), width: '441px', key: 'fileName' }
    ], [])

    const selfTableHeaders = useMemo(() => [
        { label: t('leadModal.time'), width: '200px', key: 'time' }, { label: t('leadModal.macAddress'), width: '200px', key: 'macAddress' },
        { label: t('leadModal.hvModuleAlive'), width: '200px', key: 'selfTestHVAlive' }, { label: t('leadModal.bodyImpedance'), width: '200px', key: 'selfTestBodyImpedance' },
        { label: t('leadModal.ecgCircuitAlgorithm'), width: '200px', key: 'selfTestECGCircuit' }, { label: t('leadModal.internalShock'), width: '200px', key: 'selfTestInternalShock' },
        { label: t('leadModal.internalPacingOutput'), width: '200px', key: 'selfTestInternalPacingOutput' }, { label: t('leadModal.battery'), width: '200px', key: 'selfTestBattery' },
        { label: t('leadModal.realTimeClock'), width: '200px', key: 'selfTestRealTimeClock' }, { label: t('leadModal.installedModuleAlive'), width: '200px', key: 'selfTestInstalledModuleAlive' }
    ], [])

    const markTableHeaders = useMemo(() => [
        { label: t('leadModal.markEventTime'), width: '150px', key: 'time' }, { label: t('leadModal.serialNumber'), width: '140px', key: 'serialNumber' },
        { label: t('leadModal.patientId'), width: '140px', key: 'devicePatientId' }, { label: t('leadModal.markEvent'), width: '120px', key: 'markEvent' },
        { label: t('leadModal.fileName'), width: '300px', key: 'fileName' }, { label: t('leadModal.folder'), width: '300px', key: 'folder' },
    ], [])

    const otherTableHeaders = useMemo(() => [
        { label: t('leadModal.time'), width: '150px', key: 'messageTimestamp' }, { label: t('leadModal.serialNumber'), width: '140px', key: 'serialNo' },
        { label: t('leadModal.patientId'), width: '140px', key: 'devicePatientId' }, { label: 'HR/PR', width: '120px', key: 'pulseRate' },
        { label: 'SpO2', width: '120px', key: 'spo2Percent' }, { label: 'Temp', width: '120px', key: 'temperatureCelsius' },
        { label: 'RESP', width: '120px', key: 'respRate' }, { label: 'NIBP', width: '120px', key: 'nibp' },
        { label: 'IBP', width: '120px', key: 'ibp' }, { label: 'EtCO2', width: '120px', key: 'etCo2' },
        { label: 'InCO2', width: '120px', key: 'fiCo2' }, { label: 'IPI', width: '120px', key: 'ipi' },
    ], [])

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
          ...prev,
          [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    };

    const handleSearch = async () => {
        try {
            let res = null
            const utcStart = moment(`${year.value}-${month.value}-${day.value}T00:00:00`).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
            const utcEnd = moment(`${year.value}-${month.value}-${day.value}T23:59:59`).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');

            switch(editCategory) {
                case '12LEAD':
                    res = await axios.get(`/d700/file?startTime=${utcStart}&endTime=${utcEnd}`)
                    setData(res.data.t.map(item => {
                        return {
                            ...item,
                            createdAtOrig: item.createdAt,
                            createdAt: moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
                            eventDt: moment(item.eventDt).format('YYYY-MM-DD HH:mm:ss'),
                        }
                    }))
                    break;
                case 'self':
                    res = await axios.get(`/trend/self/test/result?startTime=${utcStart}&endTime=${utcEnd}`)
                    setData(res.data.datas.map(item => {
                        return {
                            ...item,
                            time: moment(item.selfTestDate).format('YYYY-MM-DD HH:mm:ss'),
                            selfTestHVAlive: item.selfTestHVAlive ? 'X' : 'O',
                            selfTestBattery: item.selfTestBattery ? 'X' : 'O',
                            selfTestBodyImpedance: item.selfTestBodyImpedance ? 'X' : 'O',
                            selfTestECGCircuit: item.selfTestECGCircuit ? 'X' : 'O',
                            selfTestHVAlive: item.selfTestHVAlive ? 'X' : 'O',
                            selfTestInstalledModuleAlive: item.selfTestInstalledModuleAlive ? 'X' : 'O',
                            selfTestInternalPacingOutput: item.selfTestInternalPacingOutput ? 'X' : 'O',
                            selfTestInternalShock: item.selfTestInternalShock ? 'X' : 'O',
                            selfTestRealTimeClock: item.selfTestRealTimeClock ? 'X' : 'O',
                        }
                    }))
                    break;
                case 'mark':
                    setData([])
                    break;
                case 'm32':                    
                    res = await axios.get(`/trend/hl7/disconnect/vitals?startTime=${utcStart}&endTime=${utcEnd}&device=M32`)
                    setData(res.data.datas.map(item => {
                        return {
                            ...item,
                            messageTimestamp : moment(item.messageTimestamp).format('YYYY-MM-DD HH:mm:ss'),
                            nibp: `${checkEmptyValue(item.nibpSys)}/${checkEmptyValue(item.nibpDia)}/${checkEmptyValue(item.nibpMap)}`,
                            ibp: `${checkEmptyValue(item.ibpSys)}/${checkEmptyValue(item.ibpDia)}/${checkEmptyValue(item.ibpMean)}`,
                        }
                    }))
                    break;
                case 'v20':                    
                    res = await axios.get(`/trend/hl7/disconnect/vitals?startTime=${utcStart}&endTime=${utcEnd}&device=V20`)
                    setData(res.data.datas.map(item => {
                        return {
                            ...item,
                            messageTimestamp : moment(item.messageTimestamp).format('YYYY-MM-DD HH:mm:ss'),
                            nibp: `${checkEmptyValue(item.nibpSys)}/${checkEmptyValue(item.nibpDia)}/${checkEmptyValue(item.nibpMap)}`,
                            ibp: `${checkEmptyValue(item.ibpSys)}/${checkEmptyValue(item.ibpDia)}/${checkEmptyValue(item.ibpMean)}`,
                        }
                    }))
                    break;
                default:
                    break;
            }
            if (res.code != '200') throw res
            setSelectedData(null)
            setCategory(editCategory)
        } catch (err) { 
            console.warn(err)
            setData([])
            setSelectedData(null)
        }
    }

    useEffect(() => {
        // 윤년 확인 함수
        const isLeapYear = (year) => {
            return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
        };

        // 월별 일수 계산 함수
        const getDaysInMonth = (year, month) => {
            const monthNum = parseInt(month);
            
            // 2월의 경우 윤년 체크
            if (monthNum === 2) {
                return isLeapYear(parseInt(year)) ? 29 : 28;
            }
            
            // 4, 6, 9, 11월은 30일
            if ([4, 6, 9, 11].includes(monthNum)) {
                return 30;
            }
            
            // 나머지 달은 31일
            return 31;
        };

        const daysCount = getDaysInMonth(year.value, month.value);
        const dayOptions = [];
        
        // 오늘 날짜 정보
        const today = moment();
        const currentYear = parseInt(today.format('YYYY'));
        const currentMonth = parseInt(today.format('MM'));
        const currentDay = parseInt(today.format('DD'));
        
        // 선택된 연도와 월
        const selectedYear = parseInt(year.value);
        const selectedMonth = parseInt(month.value);
        
        for (let i = 1; i <= daysCount; i++) {
            // 현재 연도, 월과 비교하여 오늘 이후 날짜는 제외
            if (selectedYear > currentYear || 
                (selectedYear === currentYear && selectedMonth > currentMonth) ||
                (selectedYear === currentYear && selectedMonth === currentMonth && i > currentDay)) {
                break;
            }
            
            const dayStr = i.toString().padStart(2, '0');
            dayOptions.push({ label: dayStr, value: dayStr });
        }
        
        setDayValueArr(dayOptions);
        
        // 현재 선택된 날짜가 해당 월의 최대 일수를 초과하거나 오늘 이후인 경우 조정
        const currentDayValue = parseInt(day.value);
        const maxAvailableDay = dayOptions.length > 0 ? parseInt(dayOptions[dayOptions.length - 1].value) : 0;
        
        if (currentDayValue > maxAvailableDay && maxAvailableDay > 0) {
            const lastAvailableDay = maxAvailableDay.toString().padStart(2, '0');
            setDay({ label: lastAvailableDay, value: lastAvailableDay });
        }
    }, [year, month, day.value])

    // 초기화 완료 후 검색 실행
    useEffect(() => {
        if (isInitialized) {
            handleSearch();
            setIsInitialized(false);
        }
    }, [isInitialized]);

    useImperativeHandle(ref, () => ({
        init: () => {
            const today = moment();
            const currentYear = today.format('YYYY');
            const currentMonth = today.format('MM');
            const currentDay = today.format('DD');

            setCategory('12LEAD');
            setEditCategory('12LEAD')
            setYear({ label: currentYear, value: currentYear });
            setMonth({ label: currentMonth, value: currentMonth });
            setDay({ label: currentDay, value: currentDay });
            setDayValueArr([]);
            setDropdownStates({
                year: false,
                month: false,
                day: false,
                hour: false,
            });
            setIsInitialized(true)
        },
    }));

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" style={{ zIndex: 10000 }}>
            <div className="w-[1444px] h-[800px] bg-[#DEDEDE]" style={{ left: 500, borderRadius: 8, boxShadow: '0px 12px 12px 0px #00000099', zIndex: 5 }}>  
                <div className="flex items-center bg-[#CECECE] h-[38px]" style={{ padding: '10px 20px', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                    <span className="text-black" style={{ fontSize: 16, fontWeight: 400, lineHeight: '17.6px' }}>{view === 'list' ? t('leadModal.title') : view === 'detail' ? t('leadModal.detailTitle') : t('leadModal.title')}</span>
                    <IconCloseBlack className="ml-auto cursor-pointer" style={{ marginRight: -8 }} onClick={() => { handleClose() }}/>
                </div>
                {
                    view === 'list' &&
                    <div className="flex flex-col gap-[12px]" style={{ paddingTop: 20, paddingLeft: 20, paddingRight: 20 }}>
                        <div className="flex items-center px-5 py-5 w-full h-[112px] bg-[#CECECE] gap-4" style={{ borderRadius: 8 }}>
                            <div className="flex-grow flex flex-col gap-4">
                                <div className="flex items-center gap-4">
                                    <div className="w-[120px] text-[#444444]">{t('leadModal.category')}</div>
                                    <div className="flex-grow flex justify-between items-center">
                                        <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={editCategory === '12LEAD'}
                                                onChange={() => setEditCategory('12LEAD')}
                                            />
                                            <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>12LEAD</span>
                                        </label>
                                        <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={editCategory === 'self'}
                                                onChange={() => setEditCategory('self')}
                                            />
                                            <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>{t('leadModal.selfTest')}</span>
                                        </label>
                                        {/* <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={editCategory === 'mark'}
                                                onChange={() => setEditCategory('mark')}
                                            />
                                            <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>Mark Event</span>
                                        </label> */}
                                        <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={editCategory === 'm32'}
                                                onChange={() => setEditCategory('m32')}
                                            />
                                            <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>M32</span>
                                        </label>
                                        <label className="custom-radio">
                                            <input
                                                type="radio"
                                                checked={editCategory === 'v20'}
                                                onChange={() => setEditCategory('v20')}
                                            />
                                            <span className="font-light" style={{ color: 'black', paddingLeft: 25, fontSize: 16 }}>V20</span>
                                        </label>
                                    </div>
                                </div>
                                <div className="flex items-center gap-4">
                                    <div className="w-[120px] text-[#444444]">{t('leadModal.date')}</div>
                                    <div className="flex-grow flex justify-between items-center">
                                        <Dropdown
                                            customWidth={335}
                                            unit={t('leadModal.year')}
                                            type={'date-year'}
                                            isShow={dropdownStates.year}
                                            value={year}
                                            valueArr={yearValueArr}
                                            handleClick={(val) => { handleClickDropdown('year', val) }}
                                            handleValueClick={(val) => { setYear(val) }}
                                        />
                                        <Dropdown 
                                            customWidth={335}
                                            unit={t('leadModal.month')}
                                            type={'date-month'}
                                            isShow={dropdownStates.month}
                                            value={month}
                                            valueArr={monthValueArr}
                                            handleClick={(val) => { handleClickDropdown('month', val) }}
                                            handleValueClick={(val) => { setMonth(val) }}
                                        />
                                        <Dropdown
                                            customWidth={335}
                                            unit={t('leadModal.day')}
                                            type={'date-day'}
                                            isShow={dropdownStates.day}
                                            value={day}
                                            valueArr={dayValueArr}
                                            handleClick={(val) => { handleClickDropdown('day', val) }}
                                            handleValueClick={(val) => { setDay(val) }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="h-full w-[1px] bg-[#9F9F9F]" />
                            <div onClick={() => { handleSearch() }} className="h-full w-[160px] flex items-center justify-center rounded-[6px] bg-gradient-to-b from-[#5E5E5E] to-[#383838] font-light text-white cursor-pointer" style={{ fontSize: 16, border: '1px solid #5E5E5E' }}>
                                {t('leadModal.search')}
                            </div>
                        </div>
                        <div className="w-full h-[570px]">
                            <ListTable 
                                selectable={category === '12LEAD'}
                                data={data}
                                handledbClick={(selectedData) => { if(category === '12LEAD') { setSelectedData(selectedData); setView('detail') } }}
                                headerColumns={category === '12LEAD' ? LEADTableHeaders : category === 'self' ? selfTableHeaders : category === 'mark' ? markTableHeaders : otherTableHeaders}
                            />
                        </div>
                        {/* M32 & V20 Print 사라짐 */}
                        {/* <div className="flex justify-between items-center">
                            {
                                (category === 'm32' || category === 'v20') ?
                                <div className="flex justify-center items-center cursor-pointer w-[88px] h-[28px] bg-gradient-to-b from-[#5E5E5E] to-[#383838] text-white rounded-[6px] font-light" style={{ fontSize: 16, border: '1px solid #5E5E5E' }}>Print</div>
                                : <div />
                            }
                            <div onClick={() => { handleClose() }} className="flex justify-center items-center cursor-pointer w-[88px] h-[28px] bg-gradient-to-b from-[#FFFFFF] to-[#DEDEDE] rounded-[6px] font-light" style={{ fontSize: 16, border: '1px solid', borderImageSource: 'linear-gradient(180deg, #B8B8B8 0%, #B0B0B0 100%)' }}>Close</div>
                        </div> */}
                    </div>
                }
                {
                    view === 'detail' &&
                    <div className="flex flex-col" style={{ paddingRight: 20 }}>
                        <div className="flex h-[727px]">
                            <DetailView selectedData={selectedData} handleView={() => { setView('dicom') }}/>
                        </div>
                        <div className="flex justify-between items-center">
                            <div />
                            <div onClick={() => { setSelectedData(null); setView('list') }} className="flex justify-center items-center cursor-pointer w-[88px] h-[28px] bg-gradient-to-b from-[#FFFFFF] to-[#DEDEDE] rounded-[6px] font-light" style={{ fontSize: 16, border: '1px solid', borderImageSource: 'linear-gradient(180deg, #B8B8B8 0%, #B0B0B0 100%)' }}>{t('leadModal.list')}</div>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
})

export default LeadModal